



























import { AuthStoreHelper, RootStoreHelper } from '../../core/mixins';
import ModalCheckboxList from '../../core/components/ModalCheckboxList.vue';
import { Component, Emit, Prop, Vue, Watch, Mixins } from 'vue-property-decorator';
import {
    PRIVILEGE_KEYS
} from '../../core/utils';
import { VariablesTypes } from '../utils';

@Component({
    components: {
        ModalCheckboxList
    }
})

export default class FleetSummaryUserSettings extends Mixins(RootStoreHelper, AuthStoreHelper) {
    visibleModal: boolean = false;
    modalTitle: string = 'Columnas visibles en Resumen de Flota';
    defaultChecked: boolean = true;
    defaultSettings: object = {
        checked: this.defaultChecked
        // disabled: false,
        // loading: false,
        // disabledTooltip: '',
        // icon: null
    };
    optionalOptions: object = {
        variable_report_performance: {
            title: 'Rendimiento',
            key: VariablesTypes.PERFORMANCE,
            checked: false
        },
        variable_report_humidity: {
            title: 'Humedad',
            key: VariablesTypes.HUMIDITY,
            checked: false
        },
        variable_report_total_distance: {
            title: 'Distancia total recorrida',
            key: VariablesTypes.TOTAL_DISTANCE,
            checked: false
        },
        variable_report_total_hours_operational: {
            title: 'Horas totales de operación del motor',
            key: VariablesTypes.TOTAL_HOURS_OPERATIONAL,
            checked: false
        }
    };
    defaultOptions: object = {
        description: {
            title: 'Vehículo',
            key: 'description',
            ...this.defaultSettings
        },
        vehicle_plate: {
            title: 'Matrícula',
            key: 'vehicle_plate',
            ...this.defaultSettings
        },
        nro_norma: {
            title: 'Norma',
            key: 'nro_norma',
            ...this.defaultSettings
        },
        vin: {
            title: 'VIN',
            key: 'vin',
            ...this.defaultSettings
        },
        last_message_time_diff: {
            title: 'Último reporte',
            key: 'last_message_time_diff',
            ...this.defaultSettings
        },
        vehicle_state: {
            title: 'Estado del vehículo',
            key: 'vehicle_state',
            ...this.defaultSettings
        },
        speed: {
            title: 'Velocidad',
            key: 'speed',
            ...this.defaultSettings
        },
        location: {
            title: 'Ubicación aproximada',
            key: 'location',
            ...this.defaultSettings
        },
        driver_name: {
            title: 'Chofer',
            key: 'driver_name',
            ...this.defaultSettings
        },
        variable_report_attached_truck: {
            title: 'Camión Acoplado',
            key: 'variable_report_attached_truck',
            ...this.defaultSettings
        }

    };
    mdpOptions: object = {
        work_order_number: {
            title: 'N° OT',
            key: 'work_order_number',
            align: 'left',
            ...this.defaultSettings
        },
        work_order_mount: {
            title: 'Monte',
            key: 'work_order_mount',
            align: 'left',
            ...this.defaultSettings
        },
        work_order_dest: {
            title: 'Destino',
            key: 'work_order_dest',
            align: 'left',
            ...this.defaultSettings
        },
        work_order_unload_date: {
            title: 'Hora Descarga',
            key: 'work_order_unload_date',
            align: 'left',
            ...this.defaultSettings
        },
        work_order_load_state: {
            title: 'Estado Carga',
            key: 'work_order_load_state',
            align: 'left',
            ...this.defaultSettings
        }
    }
    smartwayOptions: object = {
        sim_iccid: {
            title: 'SIM ICCID',
            key: 'sim_iccid',
            align: 'left',
            ...this.defaultSettings
        },
        phone_number: {
            title: 'Teléfono',
            key: 'phone_number',
            align: 'left',
            ...this.defaultSettings
        },
        tdu_exceptions: {
            title: 'TDU Exceptions',
            key: 'tdu_exceptions',
            align: 'left',
            ...this.defaultSettings
        },
        tdu_application: {
            title: 'TDU Application',
            key: 'tdu_application',
            align: 'left',
            ...this.defaultSettings
        },
        tdu_memory: {
            title: 'TDU Memory',
            key: 'tdu_memory',
            align: 'left',
            ...this.defaultSettings
        },
        tdu_backup: {
            title: 'TDU Backup',
            key: 'tdu_backup',
            align: 'left',
            ...this.defaultSettings
        },
        tdu_bootloader: {
            title: 'TDU Bootloader',
            key: 'tdu_bootloader',
            align: 'left',
            ...this.defaultSettings
        }
    }
    allHeadersFleetSummary: object = {
        ...this.defaultOptions,
        ...this.optionalOptions
    };
    userHeaders: object = this.allHeadersFleetSummary;

    saveUserColumns(columns: object) {
        this.$_setUserCustomization({
            tracking_summary_json: columns
        });
    }

    closeModal() {
        this.visibilityModal(false);
        let currentColumns: any = { ...this.userHeaders };
        currentColumns = Object.values(currentColumns)
            .filter(function(item: any) {
                return item && item['checked'];
            })
            .sort((a: any, b: any) => (a.order > b.order ? 1 : -1))
            .map(function(item: any) {
                return item['key'];
            });

        this.saveUserColumns(currentColumns);
    }

    @Watch('$_getUserCustomization', { deep: true, immediate: true })
    observableUserSettings() {
        this.handleUserSettings();
    }

    turnOffAllOptions() {
        for (let i = 0; i < Object.values(this.userHeaders).length; i++) {
            let currentHeader = Object.values(this.userHeaders)[i];
            currentHeader['checked'] = false;
            currentHeader['order'] = 90 + i;
        }
    }

    updateHeadersOrder(newHeaders: Array<object>) {
        let getColumns = newHeaders.map(function(header) {
            return header['value'];
        });
        this.saveUserColumns(getColumns);
    }


    getFleetSummaryFieldsByUser(keyFields: string[]){
        //valido las columnas que llegan desde backend
        //que deberia ver solo si el usuario es MDP
        if(!this.isMdpUser){
            Object.keys(this.mdpOptions).forEach(mdpKey => {
                keyFields = keyFields.filter(function(key: string){
                    return key !== mdpKey
                })
            })
        }
        if(!this.$_getSmartwayMember){
            Object.keys(this.smartwayOptions).forEach(mdpKey => {
                keyFields = keyFields.filter(function(key: string){
                    return key !== mdpKey
                })
            })
        }

        return keyFields
    }

    checkIfNeedToShowMdpOptions(){

        if(this.isMdpUser){
            this.userHeaders  = {
                ...this.userHeaders,
                ...this.mdpOptions
            }
            this.allHeadersFleetSummary = {
                ...this.allHeadersFleetSummary,
                ...this.mdpOptions
            }
        }
    }

    checkIfNeedToShowSmartwayOptions(){
        if(this.$_getSmartwayMember){
            this.userHeaders  = {
                ...this.userHeaders,
                ...this.smartwayOptions
            }
            this.allHeadersFleetSummary = {
                ...this.allHeadersFleetSummary,
                ...this.smartwayOptions
            }
        }
    }


    handleUserSettings() {
        this.userHeaders = this.allHeadersFleetSummary;
        this.checkIfNeedToShowMdpOptions();
        this.checkIfNeedToShowSmartwayOptions();
        let savedUserSettings = this.$_getUserCustomization;
        let backendSummaryFields: string[] = savedUserSettings['tracking_summary_json'];

        backendSummaryFields = this.getFleetSummaryFieldsByUser(backendSummaryFields);
        let self = this;
        if (backendSummaryFields.length !== 0) {
            this.turnOffAllOptions(); //all user options checked false
            let headersToShowInTracking = {};
            for (let i = 0; i < backendSummaryFields.length; i++) {
                //loop through all headers keys from backend
                let savedColumn = backendSummaryFields[i]; //current key like speed, vin
                let currentOption = this.allHeadersFleetSummary[savedColumn]; //current object value
                let orderValue = i;
                if (currentOption) { 
                    currentOption['checked'] = true;
                    currentOption['order'] = orderValue;
                }

                this.userHeaders[savedColumn] = currentOption;
                headersToShowInTracking = {
                    ...headersToShowInTracking,
                    [savedColumn]: currentOption
                };
            }
            this.userHeaders = Object.values(this.userHeaders).sort((a, b) => (a.order > b.order ? 1 : -1));
            this.updateHeadersFleetSummary(
                Object.values(headersToShowInTracking).sort((a: any, b: any) => (a.order > b.order ? 1 : -1))
            );
        } else {
            this.userHeaders = this.defaultOptions;
            this.updateHeadersFleetSummary(Object.values(this.userHeaders));
        }
    }

    columnChecked(itemChecked) {
        let checkedColumns = this.getCheckedHeaders();
        this.updateHeadersFleetSummary(checkedColumns);
    }

    @Emit()
    updateHeadersFleetSummary(selectedHeaders) {
        return selectedHeaders;
    }

    @Emit()
    hideColumnFleetSummary(columnId) {
        return columnId;
    }

    @Emit()
    showColumnFleetSummary(columnId) {
        return columnId;
    }

    get isMdpUser(): boolean {
        return this.$_getPrivileges[PRIVILEGE_KEYS.MDP] == true;
    }

    getCheckedHeaders() {
        let userHeaders = Object.values(this.userHeaders).filter(function(item) {
            return item && item['checked'];
        });
        if (userHeaders.length == 0) {
            userHeaders = Object.values(this.defaultOptions).map(function(item) {
                return {
                    ...item,
                    checked: true
                };
            });
        }
        return userHeaders;
    }

    visibilityModal(value) {
        this.visibleModal = value;
    }

    configureVisibleColumns() {
        this.visibilityModal(true);
    }

    mounted() {
        this.handleUserSettings();
    }
}
